Object.defineProperty(exports, "__esModule", { value: true });
exports.Location = void 0;
var Location = (function () {
    function Location() {
    }
    Location.prototype.href = function () {
        return window.location.href;
    };
    Location.prototype.setUrl = function (url) {
        window.location.href = url;
    };
    Location.prototype.search = function () {
        return window.location.search;
    };
    Location.prototype.replace = function (url) {
        window.location.replace(url);
    };
    Location.prototype.reload = function () {
        window.location.reload();
    };
    Location.prototype.hash = function () {
        return window.location.hash;
    };
    Location.prototype.setHash = function (newHash) {
        window.location.hash = newHash;
    };
    Location.instance = new Location();
    return Location;
}());
exports.Location = Location;
//# sourceMappingURL=Location.js.map